import { useFetcherData } from "v2/hooks/useFetcherData";

import { FetcherKeys } from "routes/dataroutes/Fetchers";

import { useSubscriptionSynchronizer } from "v2/hooks/billing/useSubscriptionSynchronizer";

import { ExtractFetcherDataType } from "routes/data-routes/types";
import {
  ActiveSubscriptionDataRoutePath,
  ActiveSubscriptionDataRouteType
} from "routes/data-routes/billing-data/active-subscription/route.meta";
import { useUser } from "routes/dataroutes/UserData";
import { shouldAwaitStripeProvisioning } from "v2/utils/billingAvailability";


type HookReturnType = ReturnType<NonNullable<ActiveSubscriptionDataRouteType["useActiveSubscription"]>> & {
  subscriptionSyncPending: boolean;
  subscriptionSyncTimedOut: boolean;
  retrySubscriptionSync: () => void;
};
type FetcherDataType = ExtractFetcherDataType<HookReturnType>;

export function useActiveSubscription(): HookReturnType {
  const user = useUser();
  const { value, error, fetcher, reload } = useFetcherData<FetcherDataType>({
    fetcherKey: FetcherKeys.ACTIVE_SUBSCRIPTION,
    fetcherHref: ActiveSubscriptionDataRoutePath,
    reloadOnFocus: true
  });

  // subscription synchronization part
  const synchronization = useSubscriptionSynchronizer({
    subscription: value?.activeSubscription,
    reloadSubscription: reload,
    shouldAwaitProvisioning: shouldAwaitStripeProvisioning(user)
  });

  return {
    activeSubscription: value?.activeSubscription,
    activeSubscriptionError: error,
    activeSubscriptionFetcher: fetcher,
    reloadActiveSubscription: reload,
    ...synchronization
  };
}
